import { render, staticRenderFns } from "./accountStatistics.vue?vue&type=template&id=1e0ba8cc&"
import script from "./accountStatistics.vue?vue&type=script&lang=js&"
export * from "./accountStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports